<template>
    <div>
        <header class="header">
                <img v-if="languageIndex == 0" src="/static/img/banner1.png" alt=""> 
                <img v-else src="/static/img/banner11.png" alt=""> 
                <navHeader ref=navHeader></navHeader>
            </header>
        <main class="main">
            <nav class="nav">
                <ul>
                <li @click="aboutus()" class="pointer_box">{{langtrans().gywmm[languageIndex]}}</li>
                <li @click="news()" class="pointer_box">{{langtrans().xwzzx[languageIndex]}}</li>
                <li @click="league()" class="pointer_box" :title="langtrans().qqjylm[languageIndex]">{{langtrans().qqjylm[languageIndex]}}</li>
                <li @click="stars()" class="pick pointer_box">{{langtrans().xssffw1[languageIndex]}}</li>
                </ul>
            </nav>
            <section class="section">
                <div class="serve_box">
                    <p>{{langtrans().xssffw[languageIndex]}}</p>
                </div>
                <div class="what_box">
                    <h3>{{langtrans().rhhcww[languageIndex]}}</h3>
                    <div class="what_wrap">
                        <p class="title">✔ &nbsp; {{langtrans().xzzddj[languageIndex]}}</p>
                        <p class="title_p">Android{{langtrans().sjgnsj[languageIndex]}}Googleplay{{langtrans().xzz[languageIndex]}}</p>
                        <p class="title_p">{{langtrans().ppgsjc[languageIndex]}}AppStore{{langtrans().xzz[languageIndex]}}</p>
                            <p class="title">✔ &nbsp; {{langtrans().yycwwx[languageIndex]}}</p>
                            <p class="pt">1.	{{langtrans().txxsjh[languageIndex]}}</p>
                            <img src="/static/img/step1.png" />
                            <p class="pt">2.	{{langtrans().sdyzmh[languageIndex]}}</p>
                            <img src="/static/img/step2.png" />
                            <p class="pt">3.	{{langtrans().ddjzss[languageIndex]}}</p>
                            <img src="/static/img/step3.png" />
                            <img src="/static/img/step4.png" />
                            <p class="pt">4.	{{langtrans().yctxxx[languageIndex]}}</p>
                            <img src="/static/img/step5.png"/>
                            <p class="pt">5.	{{langtrans().zltxxw[languageIndex]}}</p>
                            <img src="/static/img/step6.png"/>
                    </div>
                </div>
            </section>
        </main>
        <p class="center">{{langtrans().xsszlt[languageIndex]}}</p>
        <vFooter @performHeader=performHeader></vFooter>
    </div>
</template>

<script>
import langtrans from "@/assets/languagejs/stars.vue.trans.js";
import { Message } from "element-ui";
import constants from "@/util/constants.js";
import navHeader from '@/components/header/indexHeader'
import vFooter from '@/components/footer/indexFooter'
export default {
  data() {
    return {
      flag: true,
      usertype: "",
      user: "",
      pwd: ""
    };
  },
  components:{
  	navHeader,
  	vFooter  	
  },
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
  methods: {
		langtrans(){
			return langtrans
		},	
    performHeader(str){
    	this.$refs.navHeader.login(str)
    },
    news(){
      this.$router.push({
        name: "news"
      });
    },
    league(){
      this.$router.push({
        name: "league"
      });
    },
    stars(){
      this.$router.push({
        name: "stars"
      });
    },
    feedback() {
      this.$router.push({
        name: "feedback"
      });
    },
    aboutus() {
      this.$router.push({
        name: "aboutus"
      });
    },
    dowapp() {
      this.$router.push({
        name: "dowapp"
      });
    },
    index() {
      this.$router.push({
        name: "Index"
      });
    },
    contact() {
      this.$router.push({
        name: "contact"
      });
    },
  }
};
</script>

<style scoped>
@import url(../../static/css/global.css);
.title_p{
  margin-left: 1.9vw;
}
.section  h3{
    font-size:1.375vw;
    font-weight: 500;
    color: #333;
}
.section .serve_box p{
    font-size: 1.125vw;
    color: #333;
    margin-top: 1.125vw;
}
.section .what_box .what_wrap{
    margin-top: 1.125vw;
}
.title{
    font-size: 1.125vw;
    height: 2.5vw;
    line-height: 2.5vw;
}
.pt{
    width: 50%;
    margin:2vw auto 0;
    font-size: 1.125vw;
    line-height: 2.125vw;
    font-weight: normal;
}
.what_wrap p{
    color: #333;
}
.what_wrap img{
    display: block;
    margin: 0.625vw auto;
    width: 50%;
}
.center{
  padding-bottom: 3.125vw;
  background: #fff;
  text-align: center;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/stars.vue